import { render, staticRenderFns } from "./Organizaciones.vue?vue&type=template&id=81a5d22e&scoped=true&"
import script from "./Organizaciones.vue?vue&type=script&lang=js&"
export * from "./Organizaciones.vue?vue&type=script&lang=js&"
import style0 from "./Organizaciones.vue?vue&type=style&index=0&id=81a5d22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a5d22e",
  null
  
)

export default component.exports